import React, { useEffect, useState } from "react";
import { useLocation, useSearchParams ,useNavigate} from "react-router-dom";
import { Button, Offcanvas } from "react-bootstrap";
import accordionSections from "../../Constants/AccordianSection";

function Services() {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const [currentSection, setCurrentSection] = useState("seafarer-overview");
  const [showOffcanvas, setShowOffcanvas] = useState(false);

  useEffect(() => {
    const fromState = location.state?.section;
    const fromQuery = searchParams.get("section");
    setCurrentSection(fromState || fromQuery || "seafarer-overview");
  }, [location.state, searchParams]);


  const handleClick = (id) => 
  {
      setCurrentSection(id);
      setShowOffcanvas(false);
      const params = new URLSearchParams(location.search);
      params.set("section", id);
      navigate(`${location.pathname}?${params.toString()}`);
  };
  const currentTab = accordionSections
    .flatMap((section) => section.items)
    .find((item) => item.id === currentSection)?.component;

    useEffect(() => {
    if (location.pathname.startsWith("/services")) {
    const queryParams = new URLSearchParams(location.search);
    const el = document.getElementById(currentSection);
    if (el && queryParams.get("section") !== null) {
      const yOffset = -150; 
      const y = el.getBoundingClientRect().top + window.scrollY + yOffset;
      setTimeout(() => {
        window.scrollTo({ top: y, behavior: 'smooth' });
      }, 100);
    }else {
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    }
  }
    }, [location.pathname, location.search, currentSection]);

return (
    <section className="services px-3 small-anchor wheel-element position-relative" id="Services">
      <div className="container max-1330 mx-auto position-relative z-1">
        <div className="row g-3 g-sm-4 g-md-5">
          <div className="col-12 text-center">
            <h1 className="section-title">Services</h1>
            <p className="d-none">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
          </div>

          <div className="col-lg-3">
            <div className="position-stiicky top-150">
              <div className="d-lg-none text-end">
                <Button variant="link" onClick={() => setShowOffcanvas(true)} className="border-0 p-0">
                  <i className="bi bi-list font-32"></i>
                </Button>
              </div>

              <Offcanvas show={showOffcanvas} onHide={() => setShowOffcanvas(false)} responsive="lg" placement="end">
                <Offcanvas.Header closeButton className="d-lg-none">
                  <Offcanvas.Title>Our Services</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                  <div
                    className="accordion leftMenu px-3 px-lg-0 pb-3 pb-md-0 overflow-auto overflow-md-visible"
                    id="accordionExample"
                  >
                    {accordionSections.map((section, index) => (
                      <div className="accordion-item" key={index}>
                        <h2 className="accordion-header">
                          <button
                            className={`accordion-button ${
                              section.items.some((item) => item.id === currentSection) ? "" : "collapsed"
                            }`}
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target={`#collapse-${index}`}
                            aria-expanded={section.items.some((item) => item.id === currentSection)}
                          >
                            {section.title}
                          </button>
                        </h2>
                        <div
                          id={`collapse-${index}`}
                          className={`accordion-collapse collapse ${
                            section.items.some((item) => item.id === currentSection) ? "show" : ""
                          }`}
                          data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body p-0">
                            <ul>
                              {section.items.map((item) => (
                                <li key={item.id}>
                                  <button
                                    type="button"
                                    className={currentSection === item.id ? "active" : ""}
                                    onClick={() => handleClick(item.id)}
                                  >
                                    {item.label}
                                  </button>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </Offcanvas.Body>
              </Offcanvas>
            </div>
          </div>

          <div className="col-lg-9">
            <div className="vertical-scrol" id={currentSection}>
              <div className="container mt-4">{currentTab}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Services;
